import React from 'react';
import Table from './table/Table';
import {observer, inject} from 'mobx-react'
import {cdn} from '../helpers/cdn';

const metadata = {
    icon: cdn('icons/bttv.svg'),
    title: 'Top BTTV Emotes',
    colorPrimary: '#ff5e65',
    colorSecondary: '#fff6f7',
};

@inject('store') @observer
class BttvTable extends React.Component {

    render() {
        const {store} = this.props;
        const {items, status} = store.bttvEmotes;
        return (
            <Table tableMetadata={metadata} status={status} data={items} tableType="bttvEmotes"/>
        );
    }
}

export default BttvTable;



// WEBPACK FOOTER //
// ./src/app/components/BttvEmotes.js